import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { IconWrapper, PasswordFieldWrapper, PasswordInput } from './PasswordField.styles';
import { ClearIcon, ShowIcon, UnShowIcon } from '../../Icon';
export const PasswordField = ({ value, setValue, state, className, onChange, onFocus, onBlur, name, ...props }) => {
    const [isFocused, setIsFocused] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const handleChange = useCallback((e) => {
        // setValue가 있으면 호출
        if (setValue) {
            setValue(e.target.value);
        }
        // onChange가 있으면 호출 (Controller 사용 시)
        if (onChange) {
            onChange(e);
        }
    }, [setValue, onChange]);
    const handleClear = useCallback(() => {
        // setValue가 있으면 호출
        if (setValue) {
            setValue('');
        }
        // onChange가 있으면 빈 문자열로 이벤트 발생
        if (onChange) {
            const event = {
                target: {
                    value: '',
                    name,
                },
            };
            onChange(event);
        }
    }, [setValue, onChange, name]);
    const handleFocus = useCallback((e) => {
        setIsFocused(true);
        if (onFocus) {
            onFocus(e);
        }
    }, [onFocus]);
    const handleBlur = useCallback((e) => {
        setIsFocused(false);
        if (onBlur) {
            onBlur(e);
        }
    }, [onBlur]);
    const togglePasswordVisibility = useCallback(() => {
        setShowPassword((prev) => !prev);
    }, []);
    return (_jsxs(PasswordFieldWrapper, { className: className, "$isFocused": isFocused, "$state": state, children: [_jsx(PasswordInput, { id: "password-input", type: showPassword ? 'text' : 'password', value: value, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur, name: name, ...props }), _jsxs(IconWrapper, { children: [value && _jsx(ClearIcon, { onClick: handleClear, style: { cursor: 'pointer' }, "aria-label": "\uC785\uB825 \uC9C0\uC6B0\uAE30" }), showPassword ? (_jsx(UnShowIcon, { onClick: togglePasswordVisibility, style: { cursor: 'pointer' } })) : (_jsx(ShowIcon, { onClick: togglePasswordVisibility, style: { cursor: 'pointer' } }))] })] }));
};
//# sourceMappingURL=PasswordField.js.map